export default __webpack_public_path__ + "static/Matrix-37c2395ec5777b355eba672af7dead77.png";